<ix-fieldset [title]="'Authentication' | translate" [formGroup]="form">
  <ix-input
    formControlName="url"
    label="URL"
    [required]="true"
    [tooltip]="helptext.url_webdav.tooltip | translate"
    [parse]="formatter.stringAsUrlParsing"
  ></ix-input>

  <ix-select
    formControlName="vendor"
    [label]="'WebDAV Service' | translate"
    [options]="vendors$"
    [required]="true"
    [tooltip]="helptext.vendor_webdav.tooltip | translate"
  ></ix-select>

  <ix-input
    formControlName="user"
    [label]="'Username' | translate"
    [required]="true"
    [tooltip]="helptext.user_webdav.tooltip | translate"
  ></ix-input>

  <ix-input
    formControlName="pass"
    type="password"
    [label]="'Password' | translate"
    [required]="true"
    [tooltip]="helptext.pass_webdav.tooltip | translate"
  ></ix-input>
</ix-fieldset>
